import React, { Component } from 'react';
import { Modal, Checkbox } from 'antd';
import styles from './index.less';

class FieldModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      attrList: props.columns || [],
    };
  }

  // 取消
  handleCancel = () => {
    const { onCancel } = this.props;

    if (onCancel) {
      onCancel(false);
    }
  };

  // 确定
  handleConfirm = () => {
    const { onConfirm } = this.props;
    const { attrList } = this.state;

    if (onConfirm) {
      onConfirm(attrList);
    }

    this.handleCancel();
  };

  // 改变字段显示状态
  handleChange = (attrSign, checked) => {
    const { attrList } = this.state;

    const newAttrList = attrList.map(attr => {
      const { visible, sign } = attr;
      return {
        ...attr,
        visible: sign === attrSign ? checked : visible,
      };
    });

    this.setState({
      attrList: newAttrList,
    });
  };

  render() {
    const { attrList = [] } = this.state;
    const modalProps = {
      title: '修改字段显示',
      wrapClassName: 'field-moal-wrap',
      onCancel: this.handleCancel,
      onOk: this.handleConfirm,
      visible: true,
    };
    return (
      <div className={styles['field-modal']}>
        <Modal {...modalProps}>
          <div className="attr-list-wrap">
            {attrList.map(({ title, sign, visible }) => {
              if (title === '操作') {
                return null;
              }
              return (
                <Checkbox
                  disabled={title === '姓名'}
                  className={title === '姓名' && 'disabled'}
                  onChange={e => this.handleChange(sign, e.target.checked)}
                  checked={visible}
                >
                  {title}
                </Checkbox>
              );
            })}
          </div>
        </Modal>
      </div>
    );
  }
}

export default FieldModal;
